import { SpaceAccessType, SpaceUpdateDto } from "@eolas-medical/core";

export const changeAccessType = (isPublic: boolean): SpaceUpdateDto => {
  const newAccessType: SpaceAccessType = isPublic ? "public" : "private";

  return {
    accessType: newAccessType,
  };
};
